export const FornecedorAlteracao = () => {
    return (
        <div></div>
    )
}